// constants.js

'use strict';

const BUSINESS_DESCRIPTION = "Family-owned laundromat in Elmira. Self-serve, wash & fold, dry cleaning, purified water refills and our famous Fresh Gear ozone sanitization.";
const AWARD_WINNING_SINCE_YEAR = "Award-Winning Laundromat";
const MORE = "More";
const LAUNDRY_AND = "Laundry &";
const BOOK_A_PICKUP = "Book a Pickup";
const SCRUBBLES_PHONE = "519-210-9274";
const TRUSTED_CUSTOMERS = "Trusted by 500+ happy customers";
const RECORD_READER_CHOICE = "Record Reader's Choice";
const X_AWARD_WINNER = "10x Award Winner";
const OUR_SERVICES = "Our Services";
const EVERYTHING_YOUR_LAUNDRY_NEEDS = "Everything Your Laundry Needs";
const FROM_SELF_SERVE = "From self-serve machines to full-service wash & fold, we've got you covered.";
const POPULAR = "Popular";
const VIEW_ALL_SERVICES = "View All Services";
const WHY_CHOOSE_US = "Why Choose Us";
const SO_MUCH_MORE_THAN = "So Much More Than Just a Laundromat";
const SCRUBBLES_HISTORY = "Established in 2010, Scrubbles is family owned, family run and fully attended. We pride ourselves in our cleanliness, customer service and state-of-the-art equipment.";
const FIFTEEN_PLUS = "15+";
const YEARS_OF_SERVICE = "Years of Service";
const TESTIMONIALS = "Testimonials";
const WHAT_OUR_CUSTOMERS_SAY = "What Our Customers Say";
const RECOGNITION = "Recognition";
const SITE_NAME = "Scrubbles Laundry";
const SITE_EMAIL = "support@scrubbleslaundry.com";
const HomePage = {  
  testimonials: [
    {
      name: "Sarah L.",
      text: "Outstanding service! They always deliver my clothes on time, perfectly cleaned and neatly pressed. The staff is friendly and professional.",
      rating: 5,
    },
    {
      name: "John M.",
      text: "They removed stubborn stains from my favorite dress that I thought were impossible. Quick turnaround and reasonable pricing.",
      rating: 5,
    },
    {
      name: "Emily S.",
      text: "Loyal customer for years. The quality of cleaning is exceptional. Pickup and delivery is a game-changer for my busy schedule.",
      rating: 5,
    },
  ]
};

export const Constants = Object.freeze({
    BUSINESS_DESCRIPTION,
    AWARD_WINNING_SINCE_YEAR,
    MORE,
    LAUNDRY_AND,
    BOOK_A_PICKUP,
    SCRUBBLES_PHONE,
    TRUSTED_CUSTOMERS,
    RECORD_READER_CHOICE,
    X_AWARD_WINNER,
    OUR_SERVICES,
    EVERYTHING_YOUR_LAUNDRY_NEEDS,
    FROM_SELF_SERVE,
    POPULAR,
    VIEW_ALL_SERVICES,
    WHY_CHOOSE_US,
    SO_MUCH_MORE_THAN,
    SCRUBBLES_HISTORY,
    FIFTEEN_PLUS,
    YEARS_OF_SERVICE,
    TESTIMONIALS,
    WHAT_OUR_CUSTOMERS_SAY,
    RECOGNITION,
    SITE_NAME,
    SITE_EMAIL,
    HomePage
    // ...
  })